import React, { useState, useEffect } from 'react';
import SoundManager from '../utils/SoundManager';

interface TerminalPromptProps {
  onCommand: (command: string) => void;
  commandHistory: string[];
  historyIndex: number;
  setHistoryIndex: React.Dispatch<React.SetStateAction<number>>;
  inputRef: React.RefObject<HTMLInputElement>;
}

const TerminalPrompt: React.FC<TerminalPromptProps> = ({ 
  onCommand, 
  commandHistory, 
  historyIndex, 
  setHistoryIndex,
  inputRef
}) => {
  const [input, setInput] = useState('');
  const [cursorVisible, setCursorVisible] = useState(true);

  // Cursor blink effect
  useEffect(() => {
    const interval = setInterval(() => {
      setCursorVisible(prev => !prev);
    }, 530);
    
    return () => clearInterval(interval);
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onCommand(input);
    setInput('');
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInput(e.target.value.toUpperCase());
    SoundManager.playSound('keypress');
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    // History navigation
    if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (commandHistory.length > 0) {
        const newIndex = Math.min(historyIndex + 1, commandHistory.length - 1);
        setHistoryIndex(newIndex);
        setInput(commandHistory[newIndex]);
      }
    } else if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (historyIndex > 0) {
        const newIndex = historyIndex - 1;
        setHistoryIndex(newIndex);
        setInput(commandHistory[newIndex]);
      } else if (historyIndex === 0) {
        setHistoryIndex(-1);
        setInput('');
      }
    }
  };

  return (
    <div className="mt-2">
      <form onSubmit={handleSubmit} className="flex items-center">
        <span className="terminal-text text-sm sm:text-base md:text-lg mr-2">GB4K:&gt;</span>
        <div className="relative flex-1">
          <input
            ref={inputRef}
            type="text"
            value={input}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            className="terminal-input w-full bg-transparent text-sm sm:text-base md:text-lg"
            spellCheck="false"
            autoComplete="off"
          />
          <div 
            className="absolute top-0 left-0 terminal-text text-sm sm:text-base md:text-lg pointer-events-none"
            style={{ marginLeft: `${input.length * 0.6}em` }}
          >
            {cursorVisible && <span className="cursor-blink">█</span>}
          </div>
        </div>
      </form>
    </div>
  );
};

export default TerminalPrompt;